export const siteSettings = {
  name: "Markets Guru",
  link: "https://marketsguru.live",
  email: "support@marketsguru.live",
  appLink: "https://app.marketsguru.live",
};
